import { Button, Modal as ModalAntd, notification, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useState } from "react";
import { BACKEND_URL } from "../../../config/config";
import { useAuth } from "../../../hooks";

import "./AccountDocumentUploadModal.css";

const { Dragger } = Upload;

export function AccountDocumentUploadModal({ account, open, onClose, onUploaded }) {
  const { user } = useAuth();
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const closeModal = () => {
    if (isUploading) return;
    setFileList([]);
    onClose();
  };

  const uploadDocument = async () => {
    if (!fileList.length) {
      notification.error({ message: "Please select a document to upload." });
      return;
    }

    const selectedFile = fileList[0].originFileObj || fileList[0];
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("accountId", account?._id);
    formData.append("contactId", user?._id);
    formData.append("contactName", user?.fullName || "");

    setIsUploading(true);

    const response = await axios
      .post(`${BACKEND_URL}/customers/accountDocument`, formData)
      .catch((err) => {
        const message =
          err?.response?.data?.message || "Unable to upload the document.";
        notification.error({ message });
        return null;
      });

    setIsUploading(false);

    if (response?.data?.status === 1) {
      notification.success({ message: "Document uploaded successfully." });
      setFileList([]);
      onClose();
      if (onUploaded) onUploaded(response.data.document);
    }
  };

  return (
    <ModalAntd
      title="Upload document"
      open={open}
      onCancel={closeModal}
      width={520}
      footer={[
        <Button key="cancel" onClick={closeModal} disabled={isUploading}>
          Cancel
        </Button>,
        <Button
          key="upload"
          type="primary"
          onClick={uploadDocument}
          loading={isUploading}
        >
          Upload
        </Button>,
      ]}
      destroyOnClose
    >
      <div className="account-upload-modal__summary">
        <span>Account</span>
        <strong>{account?.accountName || account?.companyName || "-"}</strong>
      </div>
      <Dragger
        className="account-upload-modal__dropzone"
        multiple={false}
        maxCount={1}
        fileList={fileList}
        beforeUpload={() => false}
        onChange={({ fileList: nextFileList }) => setFileList(nextFileList.slice(-1))}
        disabled={isUploading}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag a document here</p>
        <p className="ant-upload-hint">Any file type is allowed.</p>
      </Dragger>
    </ModalAntd>
  );
}
